import { render, staticRenderFns } from "./RedemptionPopup.vue?vue&type=template&id=ed3af6c4&scoped=true&"
import script from "./RedemptionPopup.vue?vue&type=script&lang=js&"
export * from "./RedemptionPopup.vue?vue&type=script&lang=js&"
import style0 from "./RedemptionPopup.vue?vue&type=style&index=0&id=ed3af6c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed3af6c4",
  null
  
)

export default component.exports